'use strict';
angular.module('resCenterXHRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.resourcectrl.xinhua.resource', {
                url: '/resource?belong&fcode&nodename&change&parentfcode&parentbelong&ispic&imgflag&doctype', // doctype->稿件类型区分文字和图片
                views: {
                    'resource@front.resourcectrl.xinhua': {
                        templateUrl: './resourceCenter/XinhuaNews/xinhua_main_tpl.html',
                        controller: 'resCenterXHRelCtrl',
                    },
                },
            })
            .state('front.resourcectrl.xinhua.quickpreview', {
                url: '/quickpreview?fcode&nodename',
                views: {
                    'resource@front.resourcectrl.xinhua': {
                        templateUrl: './resourceCenter/XinhuaNews/quickPreview/main_tpl.html',
                        controller: 'xinhuaQuickPreviewCtrl',
                    },
                },
            });
    },
]);
